import script from "./Pane.vue?vue&type=script&setup=true&lang=js"
export * from "./Pane.vue?vue&type=script&setup=true&lang=js"

import "./Pane.vue?vue&type=style&index=0&id=503f95d4&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-503f95d4"]])

export default __exports__